/* This is generated code, don't alter */
var IfcFurnitureTypeEnum;
(function (IfcFurnitureTypeEnum) {
    IfcFurnitureTypeEnum[IfcFurnitureTypeEnum["CHAIR"] = 0] = "CHAIR";
    IfcFurnitureTypeEnum[IfcFurnitureTypeEnum["TABLE"] = 1] = "TABLE";
    IfcFurnitureTypeEnum[IfcFurnitureTypeEnum["DESK"] = 2] = "DESK";
    IfcFurnitureTypeEnum[IfcFurnitureTypeEnum["BED"] = 3] = "BED";
    IfcFurnitureTypeEnum[IfcFurnitureTypeEnum["FILECABINET"] = 4] = "FILECABINET";
    IfcFurnitureTypeEnum[IfcFurnitureTypeEnum["SHELF"] = 5] = "SHELF";
    IfcFurnitureTypeEnum[IfcFurnitureTypeEnum["SOFA"] = 6] = "SOFA";
    IfcFurnitureTypeEnum[IfcFurnitureTypeEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcFurnitureTypeEnum[IfcFurnitureTypeEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcFurnitureTypeEnum || (IfcFurnitureTypeEnum = {}));
const IfcFurnitureTypeEnumCount = 9;
export { IfcFurnitureTypeEnum, IfcFurnitureTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcFurnitureTypeEnum = new Int32Array([159, 1, 1]);
let prefixSumAddressIfcFurnitureTypeEnum = new Uint32Array([0, 7, 20, 26, 33, 46, 51, 58, 64, 76]);
let slotMapIfcFurnitureTypeEnum = new Int32Array([1, 4, 2, 5, 7, 3, 0, 6, 8]);
let encodedDataIfcFurnitureTypeEnum = (new TextEncoder()).encode(".TABLE..FILECABINET..DESK..SHELF..USERDEFINED..BED..CHAIR..SOFA..NOTDEFINED.");
let IfcFurnitureTypeEnumSearch = new MinimalPerfectHash(gMapIfcFurnitureTypeEnum, prefixSumAddressIfcFurnitureTypeEnum, slotMapIfcFurnitureTypeEnum, encodedDataIfcFurnitureTypeEnum);
export { IfcFurnitureTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcFurnitureTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcFurnitureTypeEnumSearch, input, cursor, endCursor);
}
